<p [class]="variant" *ngIf="line === false">{{ text }}</p>
<div *ngIf="line" class="container__line" [class.center]="center">
	<span>{{ text }}</span>
	<div class="line" [class.center]="center"></div>
</div>
